import React, { useRef, useState, useEffect } from 'react'
import { Grid, Typography, Button, Checkbox, Drawer, List, ListItem } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { useTranslation } from 'react-i18next'
import { giftTypes } from '../shop/shopActions'

import giftList from '../shop/giftList'

const styles = theme => ({
  container: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-start'
  },
  headerContainer: {
    display: 'flex',
    width: '100%',
    height: 150,
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '270px',
    margin: `0 ${theme.spacing.unit * 2}px`
  },
  cardContainer: {
    display: 'flex',
    height: '270px',
    margin: `0 ${theme.spacing.unit * 2}px`,
    alignItems: 'flex-start'
  },
  checkbox: {
    height: '200px',
    width: '200px'
  },
  img: {
    width: '200px',
    maxHeight: '200px'
  },
  cardFooter: {
    display: 'flex',
    flexDirection: 'column',
    margin: `0 ${theme.spacing.unit * 2}px`
  },
  leftButton: {
    marginRight: 15
  },
  drawerWrapper: {
    width: 400,
    height: 40,
    position: 'relative',
  },
  drawerProps: {
    position: 'absolute',
    width: 400
  },
  listStyle: {
    display: 'flex',
    justifyContent: 'row'
  }
})

const Gifts = ({ classes, gifts, boughtGifts, receivedGifts, isLoading, fetchGifts, monetizeGift }) => {

  const { t } = useTranslation()

  const drawerContainer = useRef(null)

  useEffect(() => {
    if (!isLoading && gifts === undefined) {
      fetchGifts()
    }
  })

  const [checkedGifts, setCheckedGifts] = useState({})
  const [countChecked, setCountChecked] = useState(0)
  const [activeTab, setActiveTab] = useState(giftTypes.bought);

  const checkboxOnChange = (isChecked, key) => {
    const newCheckedGifts = { ...checkedGifts }
    newCheckedGifts[key] = isChecked
    setCheckedGifts(newCheckedGifts)
    setCountChecked((isChecked) ? countChecked + 1 : countChecked - 1)
  }

  const handleSelectAll = () => {
    let newCheckedGifts = {}
    let count = 0
    receivedGifts.forEach((val) => {
      count += val.amount
      for (let i = 0; i < val.amount; i++) {
        newCheckedGifts[`${val.id}${i}_received`] = true
      }
    })
    setCheckedGifts(newCheckedGifts)
    setCountChecked(count)
  }

  const handleMonetizeGifts = () => {
    const listToMonetize = [];
    let priceAllGifts = 0;
    let count = 0;
    receivedGifts.forEach((val) => {
      for (let i = 0; i < val.amount; i++ ) {
        if (checkedGifts[`${val.id}${i}_received`]) {
          listToMonetize.push(val.id)
          const { price } = giftList.find(g => g.id === val.id)
          priceAllGifts += price
          count++
        }
      }
    })
    // const isApprove = window.confirm(`${t('Cabinet:Monetize approve 0')} ${count} ${t('Cabinet:Monetize approve 1')} $${priceAllGifts}?`)
    const isApprove = window.confirm(t('Cabinet:Monetize approve', { count, price: priceAllGifts }))
    if (isApprove) {
      listToMonetize.forEach(item => {
        monetizeGift(item)
      })
      setCheckedGifts({})
    }
  }

  const renderTabs = () => {
    return (
      <div className={classes.drawerWrapper}
        ref={drawerContainer}>
        <Drawer
          variant='permanent'
          PaperProps={{ className: classes.drawerProps }} // required to keep Drawer in div
          BackdropProps={{ className: classes.drawerProps }} // the same
          ModalProps={{ // the same, as well
            container: drawerContainer.current,
            style: { position: 'absolute' }
          }}>
          <List className={classes.listStyle} >
            <ListItem
              button
              selected={activeTab === giftTypes.bought}
              onClick={() => setActiveTab(giftTypes.bought)}
            >
              {t('Cabinet:Bought gifts')}
            </ListItem>
            <ListItem
              button
              selected={activeTab === giftTypes.received}
              onClick={() => setActiveTab(giftTypes.received)}
            >
              {t('Cabinet:Received gifts')}
            </ListItem>
          </List>
        </Drawer>
      </div>
    )
  }

  return (
    <Grid container className={classes.container}>
      {renderTabs()}
      {
        (boughtGifts && boughtGifts.length !== 0 && activeTab === giftTypes.bought)
          ? (
            <Grid container className={classes.container}>
              <Grid container className={classes.container}>
                {
                  boughtGifts.reduce((acc, cur, idx) => {
                    // getting gift's image and price by id
                    const { image, price } = giftList.find(g => g.id === cur.id)
                    // generating view
                    const card = (key) => (
                      <Grid item className={classes.card} key={key}>
                        <img className={classes.img}
                          alt=''
                          src={image} />

                        <div className={classes.cardFooter}>
                          <Typography variant={'body2'}>
                            {`$${price}`}
                          </Typography>
                        </div>
                      </Grid>
                    )

                    // adding view to the array "amount" times
                    for (let i = 0; i < cur.amount; i++) {
                      acc.push(card(`${cur.id}${i}`))
                    }
                    return acc
                  }, [])
                }
              </Grid>
            </Grid>
          ) : null
      }
      {
        (receivedGifts && receivedGifts.length !== 0 && activeTab === giftTypes.received)
          ? (
            <Grid container className={classes.container}>
              <Grid container className={classes.headerContainer} >
                <div>
                  <Button
                    onClick={handleSelectAll}
                    variant='contained'
                    color='primary'
                    className={classes.leftButton}
                  >
                    {t('Cabinet:Select all')}
                  </Button>
                  <Button
                    disabled={(countChecked === 0)}
                    onClick={handleMonetizeGifts}
                    variant='contained'
                    color='primary'
                  >
                    {t('Cabinet:Monetize')}
                  </Button>
                </div>
              </Grid>
              <Grid container className={classes.container}>
                {
                  receivedGifts.reduce((acc, cur, idx) => {
                    // getting gift's image and price by id
                    const { image, price } = giftList.find(g => g.id === cur.id)
                    // generating view
                    const card = (key) => (
                      <Grid item className={classes.cardContainer} key={key}>
                        <input
                          checked={(!!checkedGifts[key])}
                          type="checkbox"
                          // value={'on'}
                          color="primary"
                          onChange={(event) => {
                            checkboxOnChange(event.target.checked, key)
                          }}
                        />
                        <Grid className={classes.card}>
                          <img className={classes.img}
                            alt=''
                            src={image} />

                          <div className={classes.cardFooter}>
                            <Typography variant={'body2'}>
                              {`$${price}`}
                            </Typography>
                          </div>
                        </Grid>
                      </Grid>
                    )

                    // adding view to the array "amount" times
                    for (let i = 0; i < cur.amount; i++) {
                      acc.push(card(`${cur.id}${i}_received`))
                    }
                    return acc
                  }, [])
                }
              </Grid>
            </Grid>
          ) : null
      }
    </Grid>
  )
}

export default withStyles(styles)(Gifts)
